export default __webpack_public_path__ + "static/media/6.1f1cf4aa.png";